import { Transitions } from '@mui/material';

export const transitions = {
  duration: { modalFadeDuration: 500 },
} as Transitions;
